import React from 'react';

import PlantingSeeds2024 from 'views/PlantingSeeds2024';

const AccountGeneralPage = () => {
  return <PlantingSeeds2024 />;
};

export default AccountGeneralPage;